import { addIcon } from '@iconify/vue';

/**
 * Icône de Luce, l'assistant interne.
 *
 * Enregistrée dans le registre Iconify comme n'importe quelle icône MDI :
 * elle s'utilise partout où le projet attend un nom d'icône — meta de route
 * (`icon: 'prosoluce:luce'`), <MdiIcon>, <Icon> de la sidebar.
 *
 * Le dessin : la capitale cursive de la signature, seule. Pleine et non au
 * trait, contrairement aux `mdi:*-outline` du menu — une écriture manuscrite
 * ne se détoure pas sans cesser d'être une écriture.
 */
addIcon('prosoluce:luce', {
    body: '<g fill="currentColor"><path d="M 30.6 5.2 L 28.8 4.0 L 28.1 4.0 L 25.5 7.7 L 23.1 11.6 L 20.8 15.6 L 19.0 19.4 L 16.5 25.5 L 15.0 31.3 L 14.1 37.1 L 14.1 39.0 L 14.5 40.9 L 15.1 42.3 L 15.8 43.4 L 16.8 44.5 L 18.1 45.5 L 19.3 47.0 L 21.0 48.3 L 23.0 49.1 L 26.2 49.7 L 43.6 49.7 L 43.8 49.2 L 43.9 47.4 L 43.9 44.6 L 43.8 42.8 L 43.6 42.3 L 26.4 42.3 L 22.2 42.5 L 21.1 42.5 L 21.0 42.3 L 21.0 41.1 L 22.6 33.4 L 23.7 29.9 L 25.2 25.9 L 27.2 21.5 L 29.5 17.2 L 32.1 13.1 L 34.9 9.2 L 34.7 8.6 L 33.2 7.1 Z"/></g>',
    width: 64,
    height: 64,
});
